<!-- src/App.vue -->
<template>
	<router-view />
	<SysMessageModal />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import SysMessageModal from '@/components/message/SysMessageModal.vue'

onMounted(() => {
	// 防止页面缩放
	document.addEventListener(
		'wheel',
		e => {
			if (e.ctrlKey) {
				e.preventDefault()
			}
		},
		{ passive: false }
	)

	// 防止触摸缩放
	document.addEventListener(
		'touchmove',
		e => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		},
		{ passive: false }
	)
})
</script>

<style>
/* 移动端 H5：避免系统「字体大小」导致 WebKit/部分浏览器对正文二次放大 */
html,
body {
	-webkit-text-size-adjust: 100% !important;
	text-size-adjust: 100% !important;
}

#app {
	min-height: 100vh;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

/* 全局过渡动画 */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

/* 加载动画 */
.loading-dots::after {
	content: '...';
	animation: dots 1.5s steps(4, end) infinite;
}

@keyframes dots {
	0%,
	20% {
		content: '';
	}
	40% {
		content: '.';
	}
	60% {
		content: '..';
	}
	80%,
	100% {
		content: '...';
	}
}
</style>
